import APIContainer from "../../../../components/formsAndTable/tables/dataTables/api";

const Api = () => {
  return <APIContainer />;
};

export default Api;
